import { Input, Space } from 'antd'
import React, { memo, useState, useEffect, useCallback } from 'react'
import styles from '../../index.module.less'
import { LayoutEnum } from '../../enum'
import NumberRange from '@/components/NumberRange'

const Index = (props: any) => {
  const { field, onChange, value } = props
  const { width, label, layout, allowClear } = field
  const triggerChange = v => {
    onChange?.(v)
  }
  const handleInputValueChange = e => {
    triggerChange(e)
  }
  return (
    <div className={styles.innerFieldWrap}>
      {layout === LayoutEnum.HORIZONTAL ? (
        <Space.Compact block>
          <div className={styles.addon}>{label}</div>
          <NumberRange
            value={value}
            onChange={handleInputValueChange}
            width={width}
            min={0}
            max={99999999.99}
            // placeholder={`请输入${label}`}
            // allowClear
          />
        </Space.Compact>
      ) : (
        <div className={styles.vertical}>
          <div className={styles.addon}>{label}</div>
          <NumberRange
            value={value}
            onChange={handleInputValueChange}
            width={width}
            min={0}
            max={99999999.99}
            // placeholder={`请输入${label}`}
            // allowClear
          />
        </div>
      )}
    </div>
  )
}

export default Index
